import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon, type IconName } from './Icon';
import { Button } from './Button';
import styles from './EmptyState.module.css';

export interface EmptyStateAction {
  label: string;
  to: string;
}

export interface EmptyStateProps {
  icon?: IconName;
  title?: string;
  message: ReactNode;
  /**
   * Primary CTA shown below the message. Renders a `<Button>` wrapped in a
   * react-router `<Link>` — gives empty states a clear next step (H7).
   */
  action?: EmptyStateAction;
  actions?: ReactNode;
}

export function EmptyState({
  icon = 'cat',
  title,
  message,
  action,
  actions,
}: EmptyStateProps): JSX.Element {
  return (
    <div className={styles.root}>
      <span className={styles.icon} aria-hidden>
        <Icon name={icon} size={48} strokeWidth={1.5} />
      </span>
      {title ? <p className={styles.title}>{title}</p> : null}
      <p className={styles.message}>{message}</p>
      {action ? (
        <div className={styles.actions}>
          <Link to={action.to} className={styles.actionLink}>
            <Button variant="primary">{action.label}</Button>
          </Link>
        </div>
      ) : null}
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
